/**
 * WebFooterContent — the web app's slim status strip, composed into the
 * shared `Footer` primitive.
 *
 * v35 has NO footer; this is a deliberate web-only addition (a balanced
 * frame for a full-page app) kept intentionally minimal: a product name
 * + the build marker. Until 2026-10-08 the marker was a static
 * "v2 · scaffold"; it is now the build stamp `ci-web.yml` injects (the
 * live release and its deploy date on prod — see `buildInfo.ts`).
 */
import { type BuildInfo, formatFooterVersion, readBuildInfo } from "./buildInfo";

export interface WebFooterContentProps {
  /** Injected by tests; the app reads the build env. */
  buildInfo?: BuildInfo;
}

export function WebFooterContent({ buildInfo = readBuildInfo() }: WebFooterContentProps) {
  return (
    <>
      <span>NU Assist</span>
      <span data-testid="web-footer-version">{formatFooterVersion(buildInfo)}</span>
    </>
  );
}
